import { Link } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import SectionHeading from '@/components/base/SectionHeading';
import FilmCard from '@/components/feature/FilmCard';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryShortcut from '@/pages/home/components/CategoryShortcut';
import HotList from '@/pages/home/components/HotList';
import NewsSection from '@/pages/home/components/NewsSection';
import IntroSection from '@/pages/home/components/IntroSection';
import { films } from '@/mocks/films';
import { hotFilms, latestFilms } from '@/lib/film';
import { useSeo } from '@/hooks/useSeo';

export default function HomePage() {
  useSeo({
    title: '青青草-专业影视资源平台-电影电视剧在线观看推荐',
    description:
      '青青草为您提供丰富的电影、电视剧等影视资源，涵盖最新影视资讯和精彩剧集，满足多样观看需求。畅享优质视听体验，探索精彩影视世界。',
    keywords: '青青草,影视资源,电影推荐,电视剧在线观看,影视资讯,影视平台,高清影视',
  });

  const featured = films.filter((film) => film.featured);
  const latest = latestFilms(8);
  const hot = hotFilms(6);

  return (
    <SiteLayout flush>
      <h1 className="sr-only">青青草 · 专业影视资源平台，电影电视剧在线观看推荐</h1>
      <HeroCarousel items={featured} />
      <CategoryShortcut />

      <section className="mx-auto w-full max-w-portal px-4 pt-12 md:px-6 md:pt-16">
        <SectionHeading
          eyebrow="Now Showing"
          title="最新上映影视"
          description="最近上线的电影与剧集，按年份与热度整理，点开就能看到完整资料。"
          action={{ label: '查看全部电影', to: '/category?type=movie' }}
        />
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-4">
          {latest.map((film) => (
            <FilmCard key={film.id} film={film} />
          ))}
        </div>
      </section>

      <section className="mx-auto w-full max-w-portal px-4 pt-12 md:px-6 md:pt-16">
        <SectionHeading
          eyebrow="Trending"
          title="热门影视推荐"
          description="根据站内浏览热度整理的榜单，适合不知道看什么的时候随手挑一部。"
          action={{ label: '按热度排序', to: '/category?type=tv&sort=hot' }}
        />
        <HotList items={hot} />
      </section>

      <div className="pt-12 md:pt-16">
        <NewsSection />
      </div>

      <IntroSection />

      <section className="mx-auto w-full max-w-portal px-4 pb-14 md:px-6 md:pb-20">
        <div className="flex flex-col items-start justify-between gap-4 rounded-lg border border-background-200 bg-background-50 p-6 md:flex-row md:items-center md:p-8">
          <div>
            <h2 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">
              没找到想看的那一部？
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              试试用片名、导演或演员姓名搜索，也可以在分类页组合类型与年份条件。
            </p>
          </div>
          <div className="flex w-full flex-wrap gap-3 md:w-auto">
            <Link
              to="/search?q=星海"
              className="flex flex-1 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700 md:flex-none"
            >
              <i className="ri-search-line" />
              去搜索页
            </Link>
            <Link
              to="/category?type=movie"
              className="flex flex-1 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700 md:flex-none"
            >
              <i className="ri-layout-grid-line" />
              浏览分类
            </Link>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}